import { Provider } from '@angular/core';
import { Driver, InstanceFactory, NgForageCache, NgForageConfig, NgForageOptions } from 'ngforage';

/**
 * Shared ngforage options used by every cargo-tracker app.
 *
 * All apps are deployed under the same origin, so they share the browser's
 * IndexedDB namespace. Pinning every app to a single database name
 * (`ct-storage`) prevents the browser from creating multiple, redundant
 * databases (`ngForage` + `ct-storage`) for the same logical cache.
 */
export const CT_NGFORAGE_OPTIONS: NgForageOptions = {
  name: 'ct-storage',
  driver: [Driver.INDEXED_DB, Driver.WEB_SQL, Driver.LOCAL_STORAGE],
  cacheTime: 24 * 60 * 60 * 1000, // 1 day
};

/**
 * Provider that wires up `NgForageCache` with the shared configuration.
 * Apps should include this in their root providers list (typically in
 * `main.ts`) instead of constructing their own `NgForageCache`.
 */
export function provideCtNgForageCache(): Provider {
  return {
    provide: NgForageCache,
    useFactory: (ngForageConfig: NgForageConfig = {} as NgForageConfig) => {
      ngForageConfig.configure(CT_NGFORAGE_OPTIONS);
      return new NgForageCache(ngForageConfig, new InstanceFactory(ngForageConfig));
    },
    deps: [NgForageConfig],
  };
}
